const cloudFrag = `
precision highp float;
uniform sampler2D map;
uniform sampler2D noiseTex;
uniform float time;
uniform float offset;
uniform float opacity;
uniform float alphaScaleFactor;
varying vec2 vUv;
varying float vViewDist;

void main()	{
  vec2 uv = vUv;
  float n1 = texture2D(noiseTex, uv + time *0.02).r;
  float n2 = texture2D(noiseTex, uv * 2.0 + time *0.05).r;
  float n3 = texture2D(noiseTex, uv * 4.0 + time *0.1).r;

  float n = n1 * 0.65 + n2 * 0.3 + n3 * 0.15;

  float n4 = texture2D(noiseTex, uv * 2.0 + time *0.04).r;
  float n5 = texture2D(noiseTex, uv * 1.0 + time *0.02).r;
  uv += n4 * 0.01 + n5 * 0.005;

	vec4 col = texture2D(map, uv);
  col.a *= n;
  col.a = pow(col.a, 0.6);
  col.a *= opacity;

  float dOpacity = smoothstep(5.0, 30.0, vViewDist);
  col.a *= alphaScaleFactor * dOpacity;

  gl_FragColor = col;

  // gl_FragColor.rgb = mix(vec3(1.0,0.0,0.0), vec3(0.0,0.0,0.0), vec3(dOpacity));
}
`;
export default cloudFrag;
